export const FIND_USER_REQUEST = 'infoUserReducer/FIND_USER_REQUEST';
export const FIND_USER_SUCCESS = 'infoUserReducer/FIND_USER_SUCCESS';
export const FIND_USER_FAILED = 'infoUserReducer/FIND_USER_FAILED';
export const UPDATE_USER = 'updateUser/UPDATE_USER';
export const UPDATE_USER_REQUEST = 'updateUser/UPDATE_USER_REQUEST';
export const GET_DATA_USER_POST_REQUEST = 'infoAccount/GET_DATA_USER_POST_REQUEST';
export const GET_DATA_USER_POST_SUCCESS = 'infoAccount/GET_DATA_USER_POST_SUCCESS';
export const GET_DATA_USER_POST_FAILED = 'infoAccount/GET_DATA_USER_POST_FAILED';